import React from 'react';
import './ErrorBoundary.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faSyncAlt } from '@fortawesome/free-solid-svg-icons';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
    // Reload the window to clear any fatal JS memory state bugs
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary-container">
          <div className="error-boundary-content">
            <div className="error-boundary-icon">
              <FontAwesomeIcon icon={faExclamationTriangle} />
            </div>
            <h2>Something went wrong!</h2>
            <p className="error-message">
              We encountered an unexpected error while loading this page. 
              Applying filters or displaying data may have failed.
            </p>
            <div className="error-boundary-actions">
              <button className="error-btn-primary" onClick={this.handleReload}>
                <FontAwesomeIcon icon={faSyncAlt} style={{ marginRight: '8px' }} />
                Try Again
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
